"use strict";
export function groupByPeriodAndKey(records, getPeriod, getKey) {
  const result = {};
  records.forEach((record) => {
    const period = getPeriod(record);
    const key = getKey(record);
    if (!result[period]) result[period] = {};
    result[period][key] = (result[period][key] || 0) + 1;
  });
  return result;
}
export function groupByKey(records, getKey) {
  const result = {};
  records.forEach((record) => {
    const key = getKey(record);
    result[key] = (result[key] || 0) + 1;
  });
  return result;
}
